import React, { FC } from 'react';
import { MainLayoutProps } from '../../layouts/MainLayout';
import { TagsCloudProps } from '../../components/molecules/TagsCloud';
import { HeroBannerProps } from '../../components/molecules/HeroBanner';
import { PaginationProps } from '../../components/molecules/Pagination';
import { CardsBlockProps } from '../../components/molecules/CardsBlock';
import { HtmlProps } from '../../components/atoms/Html';
import * as SC from './styled';
export type TagPageTemplateProps = MainLayoutProps & {
  heroBannerProps?: HeroBannerProps;
  title?: string;
  subtitle?: string;
  cardsBlockProps?: CardsBlockProps;
  paginationProps?: PaginationProps;
  tagsCloudProps?: TagsCloudProps;
  mainContentRef?: React.Ref<HTMLDivElement>;
  htmlProps?: HtmlProps;
  seoProps?: HtmlProps;
};
const TagPageTemplate: FC<TagPageTemplateProps> = ({
  heroBannerProps,
  title,
  subtitle,
  cardsBlockProps,
  paginationProps,
  tagsCloudProps,
  htmlProps,
  seoProps,
  mainContentRef,
  ...layoutProps
}) => {
  return <SC.Layout {...layoutProps}>
      {heroBannerProps && <SC.Hero htmlTag="header" htmlTitleTag="h1" {...heroBannerProps} />}
      <SC.MainContent ref={mainContentRef}>
        {(title || subtitle) && <SC.TextsContainer>
            {title && <SC.Title>{title}</SC.Title>}
            {subtitle && <SC.Subtitle>{subtitle}</SC.Subtitle>}
          </SC.TextsContainer>}

        {htmlProps && <SC.TextsBlock {...htmlProps} />}
        {cardsBlockProps && <SC.CardBlock {...cardsBlockProps} />}

        {paginationProps && <SC.PaginationBlock {...paginationProps} />}
      </SC.MainContent>
      {tagsCloudProps && <SC.TagCloud {...tagsCloudProps} />}
      {seoProps && <SC.TextsBlock {...seoProps} />}
    </SC.Layout>;
};
export default TagPageTemplate;